import styles from "./erro.module.css";
import { Link } from 'react-router-dom';

function Erro(){
    return(
        <div className={`${styles.root} ${styles.erro}`}>
            <h1>404</h1>
            <h2>Pagina não encontrada!</h2>
            <Link to="/" className=''>
                <button>
                Inicio
                </button>
              
            </Link>
        </div>
    );
}

export default Erro;
